import unknown_file from '@/assets/unknown_file.png'

export default {
    inserted: el => {
        const loadImage = () => {
            const imageElement = Array.from(el.children).find(el => el.nodeName === "IMG");
            if (imageElement) {
                console.log('asdas')
                imageElement.addEventListener("load", () => {
                    setTimeout(() => el.classList.add("loaded"), 100);
                });
                imageElement.addEventListener("error", (e) => e.target.src = unknown_file);
                imageElement.src = imageElement.dataset.url;
            }
        }

        const dropImage = () => {
            const imageElement = Array.from(el.children).find(el => el.nodeName === "IMG");
            if (imageElement) {
                imageElement.src = "";
            }
        }

        const handleIntersect = (entries, observer) => {
            entries.forEach(entry => {
                dropImage()
                if (entry.isIntersecting) {
                    loadImage();
                    observer.unobserve(el);
                }
            });
        }

        const createObserver = () => {
            const options = {
                root: null,
                threshold: "0"
            };
            const observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(el);
        }
        
        if (window["IntersectionObserver"]) {
            createObserver();
        } else {
            loadImage();
        }
    }
};